import { pipe, test } from 'ramda';

import { fetchValue } from './util';

export default pipe(fetchValue, test(/^\d+$/));
